class ZutyLoader {
    
    constructor() {
        this.hideLoader = localStorage.getItem('hide-loader');
        if(this.hideLoader) {
            this.hideZutyLoader();
        }
    
        if(!this.hideLoader) {
            localStorage.setItem('hide-loader', true);
            setTimeout(() => {
                this.hideZutyLoader();
            }, 2000);
        }
        
    }

    hideZutyLoader() {
        document.getElementById('zutyPageLoader').style.display = 'none';
    }
}
const zutyL = new ZutyLoader();